"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SksgV2ResetTypeValidation = void 0;
class SksgV2ResetTypeValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 9)) {
            return false;
        }
        return true;
    }
}
exports.SksgV2ResetTypeValidation = SksgV2ResetTypeValidation;
